module.exports = __webpack_public_path__ + "static/media/welcome_page.7652b467.svg";